module.exports = __webpack_public_path__ + "@/assets/img/025-girl-14.8b95651a.svg";